// src/pages/ProductTypes.tsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProductTypeService, ProductType } from "../services/productTypeService";

const ProductTypes: React.FC = () => {
  const navigate = useNavigate();
  const [productTypes, setProductTypes] = useState<ProductType[]>([]);
  const [loading, setLoading] = useState(true);
  const API_BASE = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const data = await ProductTypeService.getAll();
        setProductTypes(data);
      } catch (err) {
        console.error("Failed to fetch product types", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTypes();
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-gray-500">
        Loading Product Types…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-3">
        <h2 className="text-2xl font-semibold text-gray-900">Product Types</h2>
        <button
          onClick={() => navigate("/product-types/new")}
          className="rounded-md bg-green-600 px-4 py-2 text-white text-sm font-medium hover:bg-green-700"
        >
          + Add New
        </button>
      </div>

      <div className="overflow-x-auto rounded-lg border border-gray-300 bg-white shadow-sm">
        <table className="min-w-full text-left text-sm border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 border-b border-gray-300 font-medium text-gray-700">
                Name
              </th>
              <th className="px-4 py-2 border-b border-gray-300 font-medium text-gray-700">
                Description
              </th>
              <th className="px-4 py-2 border-b border-gray-300 font-medium text-gray-700">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {productTypes.length ? (
              productTypes.map((type) => (
                <tr key={type.id} className="hover:bg-gray-50 transition-colors">
                  <td className="border-b border-gray-300 px-4 py-2">{type.name}</td>
                  <td className="border-b border-gray-300 px-4 py-2">
                    {type.description || "-"}
                  </td>
                  <td className="border-b border-gray-300 px-4 py-2">
                    <button
                      onClick={() => navigate(`/product-types/edit/${type.id}`)}
                      className="px-3 py-1 rounded-md bg-indigo-600 text-white text-sm hover:bg-indigo-700"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="px-4 py-6 text-center text-gray-500">
                  No product types found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductTypes;
